import { isRunningInNativeApp, native } from '@muzly/shared';

/**
 * purgeDeviceRecordings — "진단 데이터 모두 삭제" 때 기기에 남은 녹음 파일을 그 자리에서 지운다.
 *
 * 웹은 파일 목록을 모른다(회차 ↔ 파일 대응이 없다) — 그래서 회차별 삭제가 아니라 네이티브가
 * takes 디렉터리를 통째로 비우는 RPC 하나다. 업로드가 끝난 테이크는 이미 지워졌으니(ADR-0007)
 * 남은 것은 업로드 못 한·안 한 테이크뿐이다. 서버 사본과 무관한 로컬 잔여물이라 서버 삭제가
 * 일부 실패했어도 부른다.
 *
 * - 브라우저에서는 부르지 않는다.
 * - `{ purged: false }` 는 네이티브가 녹음 중이라 거절한 것 — 지운 게 없고 다시 시도할 것도 없다
 *   (다음 앱 시작의 `purgeOrphans` 가 남은 걸 지운다).
 * - 이 RPC 를 모르는 옛 빌드는 `Unknown method` 로 reject 한다. 호출부가 삼킨다.
 */

/** 이 한 건에 주는 예산 — 디렉터리 하나를 비우는 일이라 5초면 넉넉하다. 재시도는 없다. */
export const PURGE_INVOKE_OPTIONS = { timeout: 5_000, retries: 1 } as const;

export interface PurgeRecordingsDeps {
  isNative: () => boolean;
  invoke: () => Promise<{ purged: boolean }>;
}

const nativePurgeDeps = (): PurgeRecordingsDeps => ({
  isNative: isRunningInNativeApp,
  invoke: () =>
    native.invoke('purgeRecordings', undefined, PURGE_INVOKE_OPTIONS),
});

export const purgeDeviceRecordings = async (
  deps: PurgeRecordingsDeps = nativePurgeDeps(),
): Promise<void> => {
  if (!deps.isNative()) {
    return;
  }
  await deps.invoke();
};
